export default __webpack_public_path__ + "static/media/Flag_of_Bhutan.454eebf9.svg";